import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  Input,
  HostListener,
} from '@angular/core';
import { ChartType, GoogleChartComponent } from 'angular-google-charts';
import { element } from 'protractor';
import { PrincipalDasboardLibService } from '../principal-dasboard-lib.service';
@Component({
  selector: 'lib-chartview',
  templateUrl: './chartview.component.html',
  styleUrls: ['./chartview.component.scss'],
})
export class ChartviewComponent implements OnInit {
  // @HostListener('window:resize', ['$event'])
  @Input() set data(res: any) {
    console.log(' IN --> 7 @Input');
    this.loadChart(res);
  }
  chartview:any;
  myDataList:any;
  chartDataTable:any;
  myChartOptions: any;
  AllrowHeight: any;
  myXmlData: any;
  currentdataList:any;
  resourceDataList:any;
  alldataList:any;
  selectedUserData:any;
  rowElements:any;
 
  installedClassrooms: any;
  currentRooms: any;
  totalUsers = 0;
  eligibleUsers = 0;
  currentUsers = 0;
  myChartType = ChartType.Timeline;
  myChartwidth = window.innerWidth * 0.88;
  myChartHeight = window.innerHeight;
  currentList = "Current Users";
  allList = "All Users";
  isAllUsers = false;
  isUserWise = false;
  myChartDataMatrix = new Array();
  id_durationMatrix = new Array();
  totalChartDataMatrix  = new Array();
  constructor(
    private pdService: PrincipalDasboardLibService
  ) { }

  ngOnInit() { }

  loadChart(response: any) {
    console.log(' IN --> 8 loadChart');
    this.totalUsers = 0;
    this.eligibleUsers = 0;
    this.currentUsers = 0;
    this.myChartType = ChartType.Timeline;
    this.myChartwidth = window.innerWidth * 0.88;
    this.myChartHeight = window.innerHeight;
    this.currentList = "Current Users";
    this.allList = "All Users";
    this.isAllUsers = false;
    this.isUserWise = false;
    this.myChartDataMatrix =[];
    this.id_durationMatrix =[];
    this.totalChartDataMatrix  =[];

    this.chartview = document.getElementById('pd-chartview');
    this.myDataList = document.getElementById('pd-xmlData');
    let parse = new DOMParser();
    this.myXmlData = parse.parseFromString(response, 'application/xml');
    if(this.myXmlData){
      this.currentdataList = this.pdService.genarateUserReqiuredData(this.myXmlData);
      this.resourceDataList = this.pdService.genarateResourseReqiuredData(this.myXmlData);
      this.totalUsers = this.currentdataList.usersMetadata.length;
      this.findCurrentUserCount();
    }
    this.pdService.chartType.subscribe((data) => {
      if (data) {
        this.updateChartType(data);
      }
    });
    this.pdService.isUserWise_data.subscribe((data) => {
      this.updateDataType(data);
    });
    window.addEventListener('resize', this.onResizeWindow.bind(this));
  }
  onResizeWindow(event: any) {
    this.myChartwidth = window.innerWidth * 0.88; //set an appropriate  factor
  }
  myChartReady() {
    this.createDivforTotalDurartion();
    this.setHeightofDivforTotalDurartion();
    this.removeBlankEntryBar();
  }
  updateChartType(dataType: any) {
    if (this.chartview != null && this.chartview != undefined) {
      if (dataType == ChartType.Table) {
        this.chartview.style.display = 'none';
      } else {
        this.chartview.style.display = 'block';
      }
    }
  }
  updateDataType(dataType: any) {
    this.isUserWise = dataType;
    if (this.myXmlData) {
      if(this.isUserWise){
        this.currentList = "Current Users";
        this.allList = "All Users";  
        if(this.isAllUsers){
          this.userWiseAllData();
        }else{
          this.userWiseCurrentData();
        } 
      }else{
        this.allList = "All Rooms";
        this.currentList = "Current Rooms";
        if(this.isAllUsers){
          this.classRoomWiseAllData();
        }else{
          this.classRoomWiseCurrentData();
        } 
      }
    }
  }
  updateChart() {
    let labels = document.getElementById('labels');
    while (labels.firstChild) {
      labels.removeChild(labels.lastChild);
    }
    this.chartDataTable = this.myChartDataMatrix;
    (this.myChartOptions = {
      tooltip: {
        trigger: 'none',
      },
      colors: ['#ff7f0e', '#2ca02c', '#8c564b', '#d62728', '#bcbd22', '#17becf'],
      timeline: {
        colorByRowLabel: true,
        barLabelStyle: {
          fontSize: 7,
        },
      },
      hAxis: {
        format: 'HH:mm a',
      },
    });
    setTimeout(() => {
      this.myChartHeight = this.AllrowHeight + 100;//to set perfect height of chart 
    }, 1000);
  }

  calulateTotalDuration(detailViewMatrix:any) {
    let id_durationArray
    this.id_durationMatrix = [];
    this.totalChartDataMatrix = [];
    if (this.isUserWise) {
      for (let i = 0; i < detailViewMatrix.length; i++) {
        id_durationArray = {
          name: detailViewMatrix[i][1],
          value: parseInt(detailViewMatrix[i][6]),
        };
        this.id_durationMatrix.push(id_durationArray);
      }
    } else {
      for (let i = 0; i < detailViewMatrix.length; i++) {
        id_durationArray = {
          name: detailViewMatrix[i][7],
          value: parseInt(detailViewMatrix[i][6]),
        };
        this.id_durationMatrix.push(id_durationArray);
      }
    }
    let obj: any = {};
    // console.log("this.id_durationMatrix",this.id_durationMatrix);

    this.id_durationMatrix.forEach((item) => {
      if (obj[item.name]) {
        obj[item.name].value = obj[item.name].value + item.value;
      } else {
        obj[item.name] = item;
      }
    });
    let valuesArr = Object.values(obj);
    let myArray = new Array();
    myArray = [];
    valuesArr.forEach((item: any) => {
      myArray.push(item.value);
    });
    for (let i = 0; i < myArray.length; i++) {
      let totaldurationPerRow = this.timeConvert(myArray[i]).toString() + ' hrs';
      let totalChartRowDataArray = [totaldurationPerRow];
      this.totalChartDataMatrix.push(totalChartRowDataArray);
    }
    // console.log('BEFORE', this.totalChartDataMatrix);
  }
  timeConvert(n: any) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + ':' + rminutes;
  }
  removeBlankEntryBar() {
    const chartDiv = document.getElementById('myTimeLine');
    var el = chartDiv.getElementsByTagName("rect");      //get all the descendant rect element inside the container      
    var width = 100000000;                                //set a large initial value to width
    var elToRem = [];                                     //element would be added to this array for removal
    for (var i = 0; i < el.length; i++) {                           //looping over all the rect element of container
      var cwidth = parseInt(el[i].getAttribute("width"));//getting the width of ith element
      if (cwidth < width) {                               //if current element width is less than previous width then this is min. width and ith element should be removed
        elToRem = [el[i]];
        width = cwidth;                               //setting the width with min width
      }
      else if (cwidth == width) {                         //if current element width is equal to previous width then more that one element would be removed
        elToRem.push(el[i]);
      }
    }
    for (var i = 0; i < elToRem.length; i++) {
      // now iterate JUST the elements to remove
      elToRem[i].setAttribute("fill", "none");

    }
  }
  createDivforTotalDurartion() {
    let rowLabels = [];
    this.rowElements = [];
    var labels = document.getElementById('labels');
    while (labels.firstChild) {
      labels.removeChild(labels.lastChild);
    }
    for (var i = 0; i < this.totalChartDataMatrix.length; i++) {
      var team = this.totalChartDataMatrix[i][0];
      rowLabels.push(team);
      var label = labels.appendChild(document.createElement('div'));
     label.style['border-bottom'] = '1px solid #b7b7b7';
      label.style['font-family'] = 'Arial';
      label.style['font-size'] = '13px';
      label.style['text-align'] = 'left';
      label.style['padding-left'] = '8px';
      label.style['padding-right'] = '8px';
      label.style.position = 'inherit';
      if (i % 2) {
        label.style['background-color'] = '#e6e6e6';
      } else {
        label.style['background-color'] = '#ffffff';
      }
      label.innerHTML = team;
      this.rowElements.push(label);
    }
  }
  setHeightofDivforTotalDurartion() {
    // console.log(" IN setHeightofDivforTotalDurartion");
    this.AllrowHeight = 0;
    const chartDiv = document.getElementById('myTimeLine');
    let rows = chartDiv.getElementsByTagName('rect');
    let rowIndex = -1;

    for (let i = 0; i < rows.length; i++) {
      rowIndex++;
      if (rowIndex < this.rowElements.length) {
        let rowHeight = parseFloat(rows[i].getAttribute('height')) + 'px';
        this.AllrowHeight += parseFloat(rows[i].getAttribute('height'));

        const currentCell = this.rowElements[rowIndex];
        if (currentCell) {
          currentCell.style.height = rowHeight;
          currentCell.style.lineHeight = rowHeight;
        }
      }
    }
  }

  onSelectRowData(event: any) {
   const { row, column } = event.selection[0];
   this.selectedUserData = this.pdService.dataForDetailedView(this.currentdataList.userConsoleData,this.resourceDataList, row)
    this.pdService.detailedviewData.next(this.selectedUserData);
    this.updateChart();
  }
  showAllUser() {
    this.pdService.isAllUsers.next(true);
    this.isAllUsers = true;
    if(this.isUserWise){
      this.userWiseAllData();
    }else{
      this.classRoomWiseAllData();
    }
  }
  showCurrentUser() {
    this.isAllUsers = false;
    this.pdService.isAllUsers.next(false);
    if(this.isUserWise){
     this.userWiseCurrentData();
    }else{
     this.classRoomWiseCurrentData();
    }
  }
 userWiseCurrentData(){
    this.myChartDataMatrix =this.pdService.userWiseChartData(this.currentdataList.userConsoleData);
    this.updateChart();
    this.calulateTotalDuration(this.currentdataList.userConsoleData);
 }
 userWiseAllData(){
    let alluserList = this.pdService.allUserChartData(this.currentdataList.userConsoleData,this.currentdataList.usersMetadata);
    this.myChartDataMatrix =alluserList.forChartData;
    this.updateChart();
    this.calulateTotalDuration(alluserList.fordurationTable);
 }
 classRoomWiseCurrentData(){
    this.myChartDataMatrix =this.pdService.classRoomWiseChartData(this.currentdataList.userConsoleData);
    this.updateChart();
    this.calulateTotalDuration(this.currentdataList.userConsoleData);
 }
 
 classRoomWiseAllData(){
   let allclassRoomList = this.pdService.allRoomsData(this.currentdataList.userConsoleData,this.currentdataList);
    this.myChartDataMatrix = allclassRoomList.forChartData;
    this.updateChart();
    this.calulateTotalDuration(allclassRoomList.fordurationTable);
 }

  findCurrentUserCount(){
    let userConsoleData = this.currentdataList.userConsoleData;
    let userNameArray = new Array();
   for (let index = 0; index < userConsoleData.length; index++) {
     const element = userConsoleData[index][1];
     userNameArray.push(element);
   }
    let uniqueUserName = [...new Set(userNameArray)];
    this.currentUsers = uniqueUserName.length;
  }
  ngOnDestroy() {
    console.log('ngOnDestroy >>');
  }
}
